module.exports = {" _key":"@dojo/widgets/list","wrapper":"list-m__wrapper__tXBYZ","transformer":"list-m__transformer__3altK","root":"list-m__root__1z7LC"};